// Power factors of the item perks (krug 5, F4), written by pnpm sim:perks (WRITE=1): for each
// catalog item and perk level, how much stronger the perk makes a survivor in a duel beyond
// what the stats it raises already count in Power. A missing entry is 1.

import raw from './perk_power.json';

export const PERK_POWER: Record<string, number> = (raw as { factors: Record<string, number> }).factors;
